import FormField from '@/shared/ui/FormField';

/** Step 1: azienda e referente. */
export default function ProfileStep({ lead, errors, onText }) {
  const field = (name) => ({
    id: `demo-${name}`,
    name,
    value: lead[name],
    error: errors[name],
    onChange: (value) => onText(name, value),
  });

  return (
    <div className="grid gap-5 md:grid-cols-2">
      <FormField
        {...field('companyName')}
        label="Azienda"
        autoComplete="organization"
        required
        placeholder="Es. Alfa Service Logistics"
        hint="Ragione sociale"
      />
      <FormField
        {...field('fullName')}
        label="Referente"
        autoComplete="name"
        required
        placeholder="Nome e cognome"
        hint="Nome completo"
      />
      <FormField
        {...field('role')}
        label="Ruolo"
        autoComplete="organization-title"
        placeholder="Es. Fleet manager, operations manager"
        hint="Facoltativo"
      />
      <FormField
        {...field('email')}
        type="email"
        label="Email"
        autoComplete="email"
        required
        placeholder="nome@azienda.it"
        hint="Contatto principale"
      />
      <FormField
        {...field('phone')}
        type="tel"
        label="Telefono"
        autoComplete="tel"
        placeholder="+39 …"
        hint="Facoltativo"
      />
    </div>
  );
}
